
import { useState } from 'react';
import BlogNavbar from './components/BlogNavbar';
import BlogHero from './components/BlogHero';
import FeaturedPost from './components/FeaturedPost';
import BlogGrid from './components/BlogGrid';
import NewsletterCTA from './components/NewsletterCTA';
import Footer from '../home/components/Footer';

export default function BlogPage() {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="min-h-screen bg-white">
      <BlogNavbar />
      <BlogHero searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
      <FeaturedPost searchQuery={searchQuery} />
      <BlogGrid searchQuery={searchQuery} />
      <NewsletterCTA />
      <Footer />
    </div>
  );
}
